export default "__VITE_ASSET__5c13b4aa__"